import { render } from "./instructor-index.vue?vue&type=template&id=2f235a4f"
import script from "./instructor-index.vue?vue&type=script&lang=js"
export * from "./instructor-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__